export const ADMIN_ROLE = 'ADMIN';
export const CUSTOMER_ROLE = 'CUSTOMER';
export const EDITOR_ROLE = 'EDITOR';
export const READER_ROLE = 'READER';
